/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * How the entry fee is collected. PER_TEAM = captain pays one flat fee for the team (default). PER_PLAYER = every roster member pays entryFee (the per-player price) when they join; charged atomically with the join.
 * @export
 */
export const TournamentFeeMode = {
    PER_TEAM: 'PER_TEAM',
    PER_PLAYER: 'PER_PLAYER'
} as const;
export type TournamentFeeMode = typeof TournamentFeeMode[keyof typeof TournamentFeeMode];


export function instanceOfTournamentFeeMode(value: any): boolean {
    for (const key in TournamentFeeMode) {
        if (Object.prototype.hasOwnProperty.call(TournamentFeeMode, key)) {
            if (TournamentFeeMode[key as keyof typeof TournamentFeeMode] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TournamentFeeModeFromJSON(json: any): TournamentFeeMode {
    return TournamentFeeModeFromJSONTyped(json, false);
}

export function TournamentFeeModeFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentFeeMode {
    return json as TournamentFeeMode;
}

export function TournamentFeeModeToJSON(value?: TournamentFeeMode | null): any {
    return value as any;
}

export function TournamentFeeModeToJSONTyped(value: any, ignoreDiscriminator: boolean): TournamentFeeMode {
    return value as TournamentFeeMode;
}

